import { render, staticRenderFns } from "./CarPlates.vue?vue&type=template&id=1f12a4b7&"
import script from "./CarPlates.vue?vue&type=script&lang=js&"
export * from "./CarPlates.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports